<template>
  <base-dialog
    :action="onAction"
    :action-name="'Cancel Booking'"
    :close="onClose"
    :cancel-name="'Back'"
    :title="'Cancel Booking'"
    :color="'error'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row
        align="center"
        justify="center"
      >
        <v-col cols="8" class="text-center">
          <div class="mb-5">Are you sure you want to cancel this booking?</div>

          <v-text-field
            v-model="cancelReason"
            dense
            outlined
            label="Reason for cancellation"
            hide-details
          />
        </v-col>
      </v-row>
    </template>

  </base-dialog>
</template>
<script>
import BaseDialog from "../Common/BaseDialog"
import { isEmpty } from 'lodash'
import { mapActions } from 'vuex'
import { isErrorResponse } from "../../services/util.service"

export default {
  components: { BaseDialog },
  props: {
    id: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      cancelReason: ''
    }
  },
  methods: {
    ...mapActions([ 'snackError', 'cancelBooking' ]),
    onAction() {
      if (isEmpty(this.cancelReason)) {
        const error = {
          text: 'Cancellation reason must be provided'
        }
        this.snackError(error)

        // Because this is not coming from an API, send the promise ourself
        return new Promise((resolve, reject) => resolve({ status: 400 }))
      } else {
        const payload = {
          id: this.id,
          cancelReason: this.cancelReason
        }

        return this.cancelBooking(payload)
          .then(res => {
            if (!isErrorResponse(res)) {
              this.$emit('action', payload)
            }
            return res
          })
      }
    },
    onClose() {

    }
  }
}
</script>
